import { IConfig } from "./config_types";

export const config: IConfig = {
	mode: (import.meta as any).env.MODE || "production",
	authType: (import.meta as any).env.VITE_AUTH_TYPE || "local",
};
